import produce from 'immer';
import {LOADER_STATUS,PROFILE_INFO,ON_GSTR_SUMMARY,ON_GSTR_SUMMARY_AMD,SET_NIL_DATA,SET_DOC_ISSUE_DATA,SET_HSN_DATA} from './constants';

// The initial state of the App
export const initialState = {
  loaderStatus: false,
  profileData:[],
  summaryData:[],
  summaryAmdData:[],
  nilData:[],
  docData:[],
  hsnData:[]
};

/* eslint-disable default-case, no-param-reassign */
const saveGstr1Reducer = (state = initialState, action) =>{
    switch (action.type) {
      case LOADER_STATUS:
        return {
          ...state,
          loaderStatus:action.loaderStatus
        }
      case PROFILE_INFO:
        return {
          ...state,
          profileData:action.profileData
        }
      case ON_GSTR_SUMMARY:
        return {
          ...state,
          summaryData:action.summaryData
        }
      case ON_GSTR_SUMMARY_AMD:
        return {
          ...state,
          summaryAmdData:action.summaryAmdData
        }
      case SET_NIL_DATA:
        return {
          ...state,
          nilData:action.nilData
        }
      case SET_DOC_ISSUE_DATA:
        return {
          ...state,
          docData:action.docData
        }
      case SET_HSN_DATA:
        return {
          ...state,
          hsnData:action.hsnData
        }
      default:
        return state; 
    }
  };

export default saveGstr1Reducer;
